<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <form class="form-horizontal" @submit.prevent="onSubmit">
          <card class="text-left">
            <template slot="header">
              <h4 class="card-title">1:1 고객문의 상세</h4>
            </template>
            <div>
              <div class="row">
                <label class="col-sm-2 col-form-label">이메일</label>
                <div class="col-sm-10">
                  <base-input placeholder="이메일" v-model="email" disabled>
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">유저아이디</label>
                <div class="col-sm-10">
                  <base-input placeholder="유저아이디" v-model="userId" disabled>
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">내용</label>
                <div class="col-sm-10">
                  <base-input placeholder="내용">
                    <textarea class="form-control" id="content" rows="3" v-model="content" disabled />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">국가코드</label>
                <div class="col-sm-10">
                  <base-input placeholder="국가코드" v-model="countryCode" disabled>
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">언어</label>
                <div class="col-sm-10">
                  <base-input placeholder="언어" v-model="locale" disabled>
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">USER AGENT</label>
                <div class="col-sm-10">
                  <base-input placeholder="유저에이전트" v-model="userAgent" disabled>
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">이미지</label>
                <div class="col-sm-10">
                  <div class="row">
                    <div class="col-sm-6" v-for="file in files" :key="file">
                      <img v-if="!file.loadFailed" class="img" :src="file.fileId | blipImageUrl" @error="onImageError(file)" />
                      <video
                        v-if="file.loadFailed"
                        :ref="'video_' + file.filePath"
                        :src="file.fileId | blipImageUrl"
                        controls
                        class="img"
                        style="max-width: 100%; height: auto"
                        @click="togglePlay(file.filePath)"
                      ></video>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">&nbsp;</div>
              <div class="row">
                <label class="col-sm-2 col-form-label">상태</label>
                <div class="col-sm-10">
                  <el-select class="select-primary" size="large" placeholder="상태" v-model="state">
                    <el-option v-for="option in states" class="select-primary" :value="option.id" :label="option.name" :key="option.name"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </card>
          <base-button native-type="submit" type="success">상태변경</base-button>
          <base-button @click="goBack" type="default">뒤로</base-button>
        </form>
        <!-- end card -->
      </div>
    </div>
  </div>
</template>
<script>
import { BaseButton, BaseInput, Card } from "@/components/index";

export default {
  components: {
    Card,
    BaseButton,
    BaseInput,
  },
  async created() {
    if (!this.$route.query.id) {
      window.Toast.error("잘못된 접근입니다");
      history.go(-1);
      return;
    }
    this.inqueryId = this.$route.query.id;
    await this.getInquery();
  },
  data() {
    return {
      faqId: null,
      content: null,
      isVisible: false,
      state: 1,
      email: null,
      userId: null,
      countryCode: null,
      locale: null,
      userAgent: null,
      files: [],
      states: [
        { id: 1, name: "접수" },
        { id: 0, name: "처리완료" },
        { id: -1, name: "삭제" },
      ],
    };
  },

  methods: {
    async getInquery() {
      const res = await this.$axios.get(`/inquery/${this.inqueryId}`);
      const data = res.data.data;
      this.content = data.content;
      this.state = data.state;
      this.email = data.email;
      this.userId = data.userId;
      this.countryCode = data.countryCode;
      this.locale = data.locale;
      this.userAgent = data.userAgent;
      const files = data.fileIds?.split(",");
      for (const fileId of files) {
        this.files.push({ fileId, loadFailed: false });
      }
    },

    onImageError(file) {
      file.loadFailed = true; // 이미지 로드 실패 시 비디오로 전환
    },

    togglePlay(filePath) {
      const video = this.$refs["video_" + filePath][0];
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    },

    async onSubmit() {
      const param = {};
      param.state = this.state;
      return this.$axios.put(`/inquery/${this.inqueryId}`, param).then((res) => {
        window.Toast.success("수정되었습니다");
        history.go(-1);
      });
    },
    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style>
.bootstrap-switch {
  margin: 6px;
}
.img {
  max-width: 100%;
  height: auto;
  cursor: pointer;
}
</style>
